import { computed, inject, onBeforeUnmount, provide, shallowReactive } from 'vue'

const PAGE_LOADING = Symbol('pageLoading')

export function providePageLoading() {
  const blockers = shallowReactive(new Set())
  provide(PAGE_LOADING, {
    track(blocker) {
      blockers.add(blocker)
      onBeforeUnmount(() => blockers.delete(blocker))
    }
  })
  return computed(() => [...blockers].some(blocker => blocker.value))
}

export const injectPageLoading = () => inject(PAGE_LOADING, null)
